import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ProjectData } from "../../models/project-evaluation.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

interface GetProjectEvaluationUseCaseParams {
  agreementId: number;
}

export class GetProjectEvaluationUseCase
  implements UseCase<GetProjectEvaluationUseCaseParams, ProjectData>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(param: GetProjectEvaluationUseCaseParams): Observable<ProjectData> {
    return this.repo.getProjectEvaluation(param.agreementId);
  }
}

const getProjectEvaluationUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new GetProjectEvaluationUseCase(repo);

export const getProjectEvaluationUseCaseProvider: Provider = {
  provide: GetProjectEvaluationUseCase,
  useFactory: getProjectEvaluationUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
